<div class="row">
  <div class="col-12 col-md-4 mb-5">
    <div class="row" [formGroup]="form">
      <div class="col-12 mb-3">
        <lib-gung-text-input-typeahead
          #gungTextInputTypeahead
          [class.d-none]="!cachedTiresWorkingOrder"
          formControlName="article"
          gungTranslate="SEARCH_TIRE"
          [list]="articles"
          (selectItem)="selectArticle($event)"
          [search]="itemIdSearchTypeahead"
          [resultFormatter]="resultFormatterItemId"
          [inputFormatter]="resultFormatterItemId"
        ></lib-gung-text-input-typeahead>
        <ng-container
          *ngTemplateOutlet="!cachedTiresWorkingOrder ? isLoading : undefined; context: { $implicit: undefined }"
        ></ng-container>
        <div *ngIf="form.get('article').disabled" class="alert alert-danger" translate>NO_TIRES_AVAILABLE</div>
      </div>

      <div class="col-12">
        <lib-gung-select-option-input
          gungTranslate="TIRE_POSITION"
          [optionsList]="tirePositionOptionsList"
          formControlName="position"
        ></lib-gung-select-option-input>
        <lib-forms-message-error [controller]="form.get('position')"></lib-forms-message-error>
      </div>

      <div class="col-12 mb-3">
        <lib-gung-select-option-input
          gungTranslate="AXLE"
          [optionsList]="tireAxleOptionsList"
          formControlName="tireAxle"
        ></lib-gung-select-option-input>
        <lib-forms-message-error [controller]="form.get('tireAxle')"></lib-forms-message-error>
      </div>

      <div class="col-12 mb-3">
        <button
          class="btn btn-primary w-100"
          (click)="addToWorkingOrder($event)"
          [disabled]="form.invalid || form.get('article').disabled"
          translate
        >
          ADD_TO_WORKING_ORDER
        </button>
      </div>

      <div class="col-12">
        <div *ngIf="noTiresSelected" class="alert alert-danger" translate>NO_TIRES_SELECTED_ERROR</div>
      </div>
    </div>
  </div>

  <div class="col-12 col-md-8 table-responsive gung-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th translate>TIRE_ID</th>
          <th translate>TIRE_NAME</th>
          <th translate>SUPPLIER_DELIVERY_NUMBER</th>
          <!--<th translate>SUPPLIER_EAN</th>-->
          <th translate>POSITION</th>
          <th translate>AXLE</th>
          <th translate>UNIT_PRICE</th>
          <th translate></th>
        </tr>
      </thead>
      <tbody *ngIf="workingOrder">
        <tr *ngFor="let row of workingOrder.tires; let index = index">
          <td [attr.data-label]="'TIRE_ID' | translate">
            <a [href]="'product/' + row.id" target="_blank">{{ row.id }}</a>
          </td>
          <td [attr.data-label]="'TIRE_NAME' | translate">
            <a [href]="'product/' + row.id" target="_blank">{{ row.name }}</a>
          </td>
          <td [attr.data-label]="'SUPPLIER_DELIVERY_NUMBER' | translate">{{ row.supplierArticleNumber || '-' }}</td>
          <!--<td [attr.data-label]="'SUPPLIER_EAN' | translate">{{ row.supplierEAN || '-' }}</td>-->
          <td [attr.data-label]="'POSITION' | translate">
            {{ row.position }}
          </td>
          <td [attr.data-label]="'AXLE' | translate">
            {{ row.tireAxle }}
          </td>
          <td [attr.data-label]="'UNIT_PRICE' | translate">
            <span *ngIf="row.price.discountPercentage && row.price.valueNoDiscount">
              <span class="linethrough">{{
                row.price.valueNoDiscount | gungCurrency : row.price.currency : 'symbol-narrow' : '1.2-2'
              }}</span>
              <span class="ml-2">(-{{ row.price.discountPercentage }}%)</span>
            </span>
            {{ row.price.value | gungCurrency : row.price.currency : 'symbol-narrow' : '1.2-2' }}
            <div *ngIf="row.errors?.price">
              <ng-template #tipContent>{{ row.errors.price }}</ng-template>
              <i class="fa fa-exclamation-triangle" aria-hidden="true" [ngbTooltip]="tipContent"></i>
            </div>
          </td>
          <td [attr.data-label]="'' | translate">
            <div class="d-flex flex-row w-100 justify-content-end">
              <button
                class="btn btn-sm btn-outline-secondary delete-button mr-1"
                (click)="removeFromWorkingOrder(index)"
              >
                <i class="fal fa-minus-circle"></i>
              </button>
            </div>
          </td>
        </tr>
        <tr *ngIf="calculatedTotals">
          <td class="hide-mobile-table"></td>
          <td class="hide-mobile-table"></td>
          <td class="hide-mobile-table"><b translate>TOTAL_QUANTITY</b></td>
          <td [attr.data-label]="'TOTAL_QUANTITY' | translate">{{ calculatedTotals.qty }}</td>
          <td class="hide-mobile-table"><b translate>TOTAL_VALUE</b></td>
          <td [attr.data-label]="'TOTAL_VALUE' | translate">
            {{ calculatedTotals.total | gungCurrency : calculatedTotals.currency : 'symbol-narrow' : '1.2-2' }}
          </td>
          <td class="hide-mobile-table"></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="row">
  <div class="col-12">
    <div class="alert alert-info mt-4">
      <span translate>WORKING_ORDER_STEP_INFO_2</span>
      <a class="here-button" translate (click)="onClick()">WORKING_ORDER_STEP_INFO_2_1</a>
      <span translate>WORKING_ORDER_STEP_INFO_2_2</span>
      <br />
      <br />
      <p translate>WORKING_ORDER_STEP_INFO_2_3</p>
    </div>
  </div>
</div>

<ng-template #isLoading>
  <i class="fa fa-spinner fa-spin fa-2x"></i>
</ng-template>
